import React from "react";
import { Paper, Stack } from "@mui/material";
import FormSection from "./FormSection";

const SectionCard = ({ title, subtitle, children }) => {
  return (
    <Paper
      className="jy-section-card"
      variant="outlined"
      sx={{
        borderRadius: 3,
        p: { xs: 2, md: 3 },
        backgroundColor: "transparent",
        boxShadow: "none",
      }}
    >
      <Stack spacing={2}>
        <FormSection title={title} subtitle={subtitle} />
        {children}
      </Stack>
    </Paper>
  );
};

export default SectionCard;
